import React, { useState } from 'react';
import { Col, Menu, Row, Skeleton } from 'antd';
import { useQueryHook } from '../shared/hooks/useQueryHook';
import { GetProfileInfo } from '../shared/common/graphqlQuery';
// import companyLogo from '../assets/companyLogo.png';
import UploadHeader from '../shared/components/uploadHeader/uploadHeader';

const AccountSettings = () => {
    const userFieldCol = (fieldName) => (
        <Col span={6} className="list__item__title">
            {fieldName}
        </Col>
    );
    const [menuKey, setMenuKey] = useState<number>(1);
    // imageURL = 'https://mondrian.mashable.com/2014%252F08%252F07%252Fa2%252Fh_51507367.9b4be.jpg%252F950x534__filters%253Aquality%252880%2529.jpg?signature=ILKeCes_KAOlKp8wsTxH-KrLKvQ=';
    const [logoUrl, setLogoUrl] = useState<any>({ loading: false, imageUrl: '' });
    const [headerUrl, setHeaderUrl] = useState<any>({ loading: false, imageUrl: '' });
    const ProfileQuery = useQueryHook(GetProfileInfo);
    const profileData = ProfileQuery.data?.getProfileInfo;

    const uploadImageLogo = (file) => {
        console.log(file, 'file');
    }
    const uploadImageHeader = (file) => {
        console.log(file, 'file');
    }

    return (
        <div style={{ height: '100%', display: 'flex' }}>
            <div style={{ width: 256, borderRight: '1px solid #f0f0f0', height: '100%' }}>
                <Menu
                    style={{ width: 256 }}
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub1']}>
                    <Menu.Item key="1" onClick={() => setMenuKey(1)}>
                        Basic Settings
                    </Menu.Item>
                    <Menu.Item key="2" onClick={() => setMenuKey(2)}>
                        Change Password
                    </Menu.Item>
                </Menu>
            </div>
            <div style={{ padding: '8px 40px', width: '100%' }}>
                {
                    menuKey === 1 ?
                        <>
                            <div className="menu__title"> Basic Settings </div>
                            {
                                ProfileQuery.loading ? <Skeleton active /> : <>
                                    <Row>
                                        {userFieldCol('User Name:')}
                                        {userFieldCol(profileData.name)}
                                    </Row>
                                    <Row>
                                        {userFieldCol('Company Name:')}
                                        {userFieldCol(profileData.companyName)}

                                    </Row>
                                    <Row>
                                        {userFieldCol('Email:')}
                                        {userFieldCol(profileData.email)}

                                    </Row>
                                    <Row>
                                        {userFieldCol('Company Phone no:')}
                                        {userFieldCol(profileData.companyPhone)}
                                    </Row>
                                    {
                                        profileData.gstnNumber ?
                                            <Row>
                                                {userFieldCol('GSTN Number:')}
                                                {userFieldCol(profileData.gstnNumber)}

                                            </Row>
                                            : ''
                                    }
                                    <Row style={{ paddingTop: 10, height: 200, maxHeight: 200 }}>
                                        <UploadHeader imageUrlConst={logoUrl} imageMsg="Upload Company Logo" uploadImage={uploadImageLogo}></UploadHeader>
                                        <UploadHeader style={{ marginLeft: 15 }} imageUrlConst={headerUrl} imageMsg="Upload PDF Header" uploadImage={uploadImageHeader}></UploadHeader>
                                    </Row>
                                </>
                            }
                        </>
                        : <>
                            <div className="menu__title"> Change Password </div>
                        </>
                }
            </div>
        </div>
    );
}
export default AccountSettings